import { createSelector } from 'reselect';

import { initialState } from './reducer';

const selectRegister = (state) => state.register || initialState;

const selectRegisterError = createSelector(selectRegister, (registerState) => registerState.registerError);

export { selectRegisterError };
